import React from 'react';
import ResourcePage from './ResourcePage';
import { getFarmerResource } from '../../data/farmerResources';

const FarmerVerificationPage = () => <ResourcePage resource={getFarmerResource('farmer-verification')} />;
export default FarmerVerificationPage;
